export default __webpack_public_path__ + "static/media/logo-1.b67e05ae.svg";